/** Hungru GraphQL/REST origin — commission leads POST to /api/art-commission-leads */
export function getCommissionApiBaseUrl(): string {
  const fromEnv = process.env.REACT_APP_COMMISSION_API_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/$/, "");
  }
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:4000";
  }
  return "https://gql.hungru.co";
}

export function getCommissionLeadsEndpoint(): string {
  return `${getCommissionApiBaseUrl()}/api/art-commission-leads`;
}
